// extracted by mini-css-extract-plugin
export default {"prefixSuffixBox":"index_prefixSuffixBox__ti2ep","prefixSuffixBoxSuffix":"index_prefixSuffixBoxSuffix__f6GGL","disabled":"index_disabled__6Ca1I"};